import { Fragment, VFC } from 'react';
import { VoteBoxContent } from '../VoteBoxContent';
import { IVoteBoxProps } from './types';
import { format } from 'date-fns';
import { DateFormat, VoteResult } from '../../config/variables';
import { ReactComponent as AcceptedIcon } from 'assets/icons/accepted.svg';
import { ReactComponent as RejectedIcon } from 'assets/icons/rejected.svg';
import { cs } from 'date-fns/locale';
import {
  StyledH4,
  StyledVoteBox,
  StyledVoteIcon,
  StyledVotesList,
  StyledVotesListContent,
} from './VotesList.style';

export const VotesList: VFC<{ votes?: IVoteBoxProps[] }> = ({ votes }) => {
  let oldDate: Date = new Date();

  const renderVoteBox = (vote: IVoteBoxProps, index: number) => {
    const dateObject = new Date(vote.date);

    const isMonthChanged =
      oldDate.getMonth() !== dateObject.getMonth() ||
      oldDate.getFullYear() !== dateObject.getFullYear();

    oldDate = dateObject;

    return (
      <Fragment key={vote.id}>
        {(isMonthChanged || index === 0) && (
          <StyledH4>
            {`${format(dateObject, 'LLLL', {
              locale: cs,
            })} ${dateObject.getFullYear()}`}
          </StyledH4>
        )}
        <StyledVoteBox
          to={`/detail/${vote.id}`}
          onClick={() => window.scrollTo(0, 0)}
        >
          <StyledVoteIcon>
            {vote.result === VoteResult.Accepted ? (
              <AcceptedIcon />
            ) : (
              <RejectedIcon />
            )}
          </StyledVoteIcon>
          <VoteBoxContent
            subject={vote.subject}
            date={format(dateObject, DateFormat.Date)}
            result={vote.result}
            meetingCode={vote.meetingCode}
            id={vote.id}
          />
        </StyledVoteBox>
      </Fragment>
    );
  };

  if (!votes) {
    return null;
  }

  return (
    <StyledVotesList>
      <StyledVotesListContent>
        {votes.map((v, i) => renderVoteBox(v, i))}
      </StyledVotesListContent>
    </StyledVotesList>
  );
};
